// extracted by mini-css-extract-plugin
module.exports = {"button":"ModalWithButton_button__2AiBC","buttonTitle":"ModalWithButton_buttonTitle__2YxSP","icon":"ModalWithButton_icon__19XD8"};